// 一个指令，当点击按钮的时候，发送日志协议
import { useGlobalState } from "./store";
const { initData, isLogin } = useGlobalState()

export default {
  mounted(el, binding) {
    el.addEventListener('click', () => {
      // /h5/tx3/us/collect_log 
      // 贰，天下3地址

      // 手游地址
      let data = new FormData()
      data.append('activity', import.meta.env.VITE_NAME)
      data.append('op_code', 'click_btn')
      data.append('details', JSON.stringify(binding.value))
      data.append('server_group',import.meta.env.VITE_TEAM == "tx2" ? 2 : 1)
      if (isLogin.value) {
        console.log('已登录')
        data.append('h5user_id', initData.role_info.role_id)
        data.append('account_id', initData.account_data.username)
        data.append('role_name', initData.role_info.role_name)
        data.append('role_id', initData.role_info.role_id)
      } else {
        data.append('h5user_id', window.figureCode)
      }
      console.log('点击发送日志', binding.value)
      fetch(`${import.meta.env.VITE_BASEAPI}/h5/tx3/us/collect_log `, {
        method: "POST",
        body: data
      })
    });
  },
  unmounted(el) {
    el.removeEventListener('click', () => { });
  }
};